import React, { useEffect, useState } from "react";
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import Language from "Enums/Language"
import { useHistory } from 'react-router-dom';
import { adminPrefix } from "configs/routePrefix";
import FileUpload from "./fileUpload";

const languages = ["en", "ar", "zh", "ru"]

function ModalForm({
    modal,
    toggle,
    isAdd,
    setShouldGetData,
    editObj,
    Service
}) {
    const [loading, setLoading] = useState(false)
    const [mediaIds, setMediaIds] = useState([])
    const [columns, setColumns] = useState([])
    const [uploadState, setUploadState] = useState(false)
    const service = new Service
    const history = useHistory();

    const [formData, setFormData] = useState({
        en: "",
        ar: "",
        ru: "",
        zh: "",
        options: []

    })
    useEffect(() => {
        if (editObj ?.id) {
            service.find(editObj ?.id).then(res => {
                if (res && res.status === SuccessOk) {
                    setFormData({
                        // ...formData,
                        ...res.data,
                        ...res.data.name
                    })
                }
            })
        }
    }, [])

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const updatedAttachment = (attachments) => {
        setMediaIds([...mediaIds, ...attachments])
    }

    const deleteAttachment = (Items, type) => {
        let updatedMedia = mediaIds.filter(item => item.id !== Items[0].id)
        setMediaIds(updatedMedia)
    }

    const handleValidSubmit = () => {
        if(isAdd && mediaIds.length == 0){
            toast.error("Upload Sheet Template are Required")
            return
        }
        setLoading(true)
        let data ={}
        if(isAdd){
            data = {
                name: {
                    en: formData.en,
                },
                media: mediaIds,
                columns: columns,
                isAdd: isAdd
            }
        } else {
            data = {
                name: formData?.name,
                compound_details: formData?.compound_details,
                building_status: formData?.building_status,
                areas: formData?.areas,
                general: formData?.general,
                developer_id: formData?.developer?.id,
                other: formData?.other,
            }
        }
        
        languages.forEach(language => {
            if (formData[language]?.length) {
                data.name[language] = formData[language]
            }
        })

        if(isAdd){
            history.push({
                pathname: `${adminPrefix}/setting/inventory/wirframe`,
                state: { props: data }
            });
        } else {
            service.update(editObj?.id, data).then(res=>{
                if (res && res.status === SuccessOk) {
                    setLoading(false)
                    setShouldGetData(true)
                    toast.success("Sheet Name Updated Successfully")
                    toggle()
                } else{
                    toast.error(res)
                }
            })
        }
        // if (isAdd) {
        //     let data = {
        //         name: {
        //             en: formData.en,
        //         },
        //         media: mediaIds
        //     }
        //     languages.forEach(language => {
        //         if (formData[language].length) {
        //             data.name[language] = formData[language]
        //         }
        //     })
            
        //     service.create(data).then(res => {
        //         if (res && res.status === SuccessCreated) {
        //             setShouldGetData(true)
        //             toast.success("Unit Size Added successfully")
        //             toggle()
        //         }else{
        //             setLoading(false)
        //         }
        //     })
        // } else {
        //     let data = {
        //         name: {
        //             en: formData.en,
        //             ar: formData.ar,
        //             ru: formData.ru,
        //             zh: formData.zh
        //         },
        //         media: mediaIds
        //     }
        //     service.update(editObj.id, data).then(res => {
        //         if (res && res.status === SuccessOk) {
        //             setShouldGetData(true)
        //             toast.success("Unit Size Edited Successfully")
        //             toggle()
        //         }else{
        //             setLoading(false)
        //         }
        //     })
        // }
    }

    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <ModalHeader toggle={toggle}>
                {isAdd ? `Add Inventory ` : `Update Inventory`}
            </ModalHeader>
            <ModalBody>
                <AvForm
                    className='form-horizontal'
                    onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v);
                    }}>
                    <Row>
                        {Language.LIST.map((lan, index) => {
                            return (
                                <Col md={6} key={index} className="mb-3">
                                    <AvField
                                        name={lan.name}
                                        label={lan.label}
                                        bsSize="lg"
                                        value={formData[`${lan.name}`]}
                                        onChange={(e => handleFieldChange(e))}
                                        validate={{
                                            required: {value: lan.name === "en" ? true : false, errorMessage: 'This Field is required'},
                                            pattern: {value: lan.name === "en" ? '/^[A-Za-z ]+$/' : lan.name === "ar" ? '/^[\u0621-\u064A ]+$/' : "", errorMessage: `${lan.name=='en' ? "English" : "Arabic"} format is invalid`}
                                        }}
                                        placeholder={lan.name === "en" ? 'Name' : lan.name === "ar" ? "الاسم" : lan.name === "zh" ? "姓名" : "Каир"}
                                    />
                                </Col>
                            )
                        })}
                        {isAdd && <Col md={12} className='mt-3'>
                            <FileUpload
                                accept='.xlsx,.xls,.csv'
                                label="Upload Sheet Template"
                                attachmentType='media_id'
                                setUpload={()=> {}}
                                attachmentData={mediaIds}
                                setColumns={setColumns}
                                updatedAttachment={updatedAttachment}
                                deleteAttachment={deleteAttachment}
                                multiple
                                setUploadState={setUploadState}
                            />
                        </Col>}
                    </Row>

                    <ModalFooter className="px-0">
                        {/* <button 
                            onClick={toggle}
                            type='button' 
                            className='btn btn-secondary' 
                            style={{width: "45%"}}>
                            Cancel
                        </button> */}
                        <button
                            disabled={uploadState ? true : loading ? true : false}
                            style={{width: "45%"}}
                            type='submit' className='btn btn-success ms-auto'>
                            {isAdd ? `Next ` : `Submit`}
                        </button>
                    </ModalFooter>
                </AvForm>
            </ModalBody>
        </Modal>
    );
}

export default ModalForm;
